<div class="table-container">
  <table
    mat-table
    [dataSource]="dataSource$"
    class="table"
    matSort
    cdkDropList
    cdkDropListOrientation="horizontal"
    (cdkDropListDropped)="listDropped($event)"
    [ngClass]="{ loaded: !isLoading, 'hidden-table': !isLoading && (noData || hasError) }"
  >
    <ng-container
      *ngFor="let property of propertyColumns; index as i"
      [matColumnDef]="property.name"
    >
      <th
        mat-header-cell
        cdkDrag
        [mat-sort-header]="canSort ? property.name : null"
        *matHeaderCellDef
        [disabled]="canSort ? false : true"
        [style.width]="isLoading ? columnWidths[i] + '%' : 'auto'"
      >
        {{ property.displayName }}
      </th>
      <td mat-cell *matCellDef="let row">
        <ng-container *ngIf="property.displayOptions?.isChippable; else basicCell">
          <div class="chip d-flex jc-center ai-center" [ngStyle]="getChipStyles(row, property)">
            <span style="flex: 0 0 auto">{{ row.data[property.name] }}</span>
          </div>
        </ng-container>
        <ng-template #basicCell>
          <ng-container [ngSwitch]="property.type">
            <span *ngSwitchCase="'DATE'">{{ row.data[property.name] | date: 'd MMM yyyy' }}</span>
            <span *ngSwitchDefault [class.index-value]="property.name === 'index'">{{
              row.data[property.name]
            }}</span>
          </ng-container>
        </ng-template>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="propertyColumnNames"></tr>
    <tr
      mat-row
      class="row"
      [class.hidden]="isLoading"
      *matRowDef="let row; columns: propertyColumnNames"
      [routerLink]="useRouteNavigation ? getRowRouterLink(row) : null"
      (click)="onRowClick(row, $event)"
    ></tr>
  </table>
</div>
<ng-container *ngIf="isLoading">
  <div *ngIf="options.loadingType == 'spinner'" class="loading-spinner-container">
    <suvo-core-loading-spinner [message]="'Searching'"></suvo-core-loading-spinner>
  </div>
  <ng-container *ngIf="options.loadingType != 'spinner'">
    <suvo-bi-skeleton-table-rows
      class="skeleton"
      [rowCount]="pageSize"
      [columnWidths]="columnWidths"
    ></suvo-bi-skeleton-table-rows>
  </ng-container>
  <div style="border-bottom: 1px solid rgba(0, 0, 0, 0.12)"></div>
</ng-container>
<ng-container *ngIf="!isLoading && !hasError && noData">
  <div class="no-data-container">
    <!--[style.height.px]="(matPaginator?.pageSize || pageSize) * 48"-->
    <ng-content select="[noDataContent]"></ng-content>
  </div>
</ng-container>

<ng-container *ngIf="!isLoading && hasError">
  <div class="no-data-container">
    <ng-content select="[errorContent]"></ng-content>
    <div class="d-flex fd-col jc-center ai-center">
      <suvo-core-icon-message
        title="Unable to load data"
        message="Please try different filters and retry."
      ></suvo-core-icon-message>
    </div>
  </div>
</ng-container>

<!-- <div class="d-flex fd-col gap-16" style="margin-left: 16px; font-weight: 700; opacity: 0.7">
  <span>Subjects</span>
  <span>Pagination: {{ (paginationSubject | async) | json }}</span>
  <span>Sort: {{ (sortSubject | async) | json }}</span>
  <span>Filters: {{ (filtersSubject | async)?.dataSourceFilters?.name }}</span>
</div> -->

<mat-paginator
  [hidden]="!options.showPageControls"
  [pageSize]="pageSize"
  [hidePageSize]="!options.showPageSizeOptions"
  [pageSizeOptions]="options.showPageSizeOptions && pageSizeOptions"
  showFirstLastButtons
></mat-paginator>
